import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiBell, FiEye, FiMapPin } from "react-icons/fi";
import { FaHeart } from "react-icons/fa";
import { MdHeight } from "react-icons/md";
import { RiGraduationCapLine } from "react-icons/ri";
import { IoHeartDislikeOutline, IoMoonOutline } from "react-icons/io5";
import "./SelectItemPage.css";
import { CiCircleRemove } from "react-icons/ci";
import { useDashboardContext } from "../../context/Dashboard_context";
import Loader from "../../components/Loader";
import { getAgeFromDob } from "../../utils/helper";

const MatchCard = ({ profile, onRemove, onView }) => (
  <div className="si-card">
    <div className="si-card-top">
      <div className="si-photo-wrap">
        <img src={profile.photo_url} alt={profile.name} className="si-photo" />
        <div className="si-heart-badge">
          <FaHeart size={13} />
        </div>
      </div>
      <div className="si-info">
        <div className="si-name">
          {typeof profile.name === "object" ? profile.name?.name : profile.name}
        </div>
        <div className="si-age">{getAgeFromDob(profile.dob)} yrs</div>
        <div className="si-location">
          <FiMapPin />
          {profile.address}
        </div>
        <div className="si-profession">{profile.job}</div>
      </div>
    </div>

    <div className="si-stats">
      <div className="si-stat">
        <span className="si-stat-icon">
          <MdHeight size={20} color="#667eea" />
        </span>
        <span className="si-stat-label">Height</span>

        <span className="si-stat-value">{profile.height}</span>
      </div>
      <div className="si-stat">
        <span className="si-stat-icon">
          <RiGraduationCapLine size={17} color="#e05c7a" />
        </span>
        <span className="si-stat-label">Education</span>
        <span className="si-stat-value">{profile.education}</span>
      </div>
      <div className="si-stat">
        <span className="si-stat-icon">
          <IoMoonOutline size={15} color="#f5a623" />
        </span>
        <span className="si-stat-label">Religion</span>
        <span className="si-stat-value">{profile.religion?.name}</span>
      </div>
    </div>

    <div className="si-actions">
      <button className="si-btn-remove" onClick={() => onRemove(profile.id)}>
        <CiCircleRemove size={16} style={{ strokeWidth: "1" }} /> Remove
      </button>
      <button className="si-btn-view" onClick={() => onView(profile)}>
        <FiEye size={14} /> View Profile
      </button>
    </div>
  </div>
);

const SelectItem = () => {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const { selected_data, selected_loading, GetSelectedList, SelectPerson } =
    useDashboardContext();

  useEffect(() => {
    GetSelectedList();
  }, []); //eslint-disable-line

  const handleRemove = (id) => {
    setSelectedId(id);
    setOpenModal(true);
  };
  const confirmRemove = async () => {
    const formdata = new FormData();
    formdata.append("form_id", String(selectedId));
    formdata.append("is_select", "0");

    await SelectPerson(formdata, navigate);
    GetSelectedList(navigate);

    setOpenModal(false);
    setSelectedId(null);
  };

  const handleView = (profile) => {
    localStorage.removeItem("selected_profile");
    localStorage.setItem("selected_profile", JSON.stringify(profile));

    navigate(`/details/${profile.id}`, {
      state: { profile },
    });
  };
  return (
    <div className="si-page">
      <header className="si-header">
        <span className="si-header-title">Your Matches</span>
        <button className="si-bell-btn">
          <FiBell size={25} />
        </button>
      </header>
      <div className="si-banner-wrapper">
        <div className="si-banner">
          <div className="si-banner-icon">
            <FaHeart size={24} />
          </div>
          <div>
            <div className="si-banner-count">{selected_data.length}</div>
            <div className="si-banner-label">Total Matches</div>
          </div>
        </div>
      </div>
      {selected_loading ? (
        <Loader />
      ) : (
        <main className="si-main">
          {selected_data.length === 0 ? (
            <div className="si-empty">
              <div className="si-empty-icon">
                <IoHeartDislikeOutline size={56} />
              </div>
              <p className="si-empty-title">No matches yet</p>
              <p className="si-empty-sub">
                Like profiles from Home to see your matches here
              </p>
            </div>
          ) : (
            <div className="si-cards-grid">
              {selected_data.map((profile) => (
                <MatchCard
                  key={profile.id}
                  profile={profile}
                  onRemove={handleRemove}
                  onView={handleView}
                />
              ))}
            </div>
          )}
        </main>
      )}
      {openModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h2>Remove Match</h2>
            <p>Are you sure you want to remove this match?</p>

            <div className="modal-actions">
              <button
                className="cancel-btn"
                onClick={() => setOpenModal(false)}
              >
                Cancel
              </button>

              <button className="remove-btn" onClick={confirmRemove}>
                Remove
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectItem;
